import { useTranslation } from "@1f/react-sdk";
import Divider from "@vapor/react-material/Divider";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const AnagraficaPartecipazioneSection = ({
  currentAnagraficaFascicolo,
  currentAnagrafica,
  baseTipoPartList,
  showTipoPartDesc,
  loggedUserId,
  isCessato,
  isNotLastVersion,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Divider variant="standard" sx={{ pt: 2 }} />
      <ExtendedTypography variant="titleSmall" color="primary.main">
        {t("anagrafica.anagraficaForm.partTip")}
      </ExtendedTypography>

      <Autocomplete
        id="ddlTipoPart"
        size="small"
        options={baseTipoPartList}
        sx={{ width: "100%" }}
        fullWidth
        onChange={onChange}
        isOptionEqualToValue={(option, value) =>
          currentAnagraficaFascicolo.tipoPartId === undefined
            ? option.id === value.id
            : option.id === currentAnagraficaFascicolo.tipoPartId
        }
        getOptionLabel={(option) => option.descrizione}
        groupBy={(option) => option.nome}
        defaultValue={
          currentAnagraficaFascicolo.tipoPartId !== undefined
            ? baseTipoPartList.filter(
                (item) => item.id === currentAnagraficaFascicolo.tipoPartId
              )[0]
            : null
        }
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label="Tipologia Partecipazione"
            sx={{ lineHeight: 1 }}
          />
        )}
        readOnly={
          currentAnagrafica.identifiedByUser === loggedUserId
            ? isCessato || isNotLastVersion
            : false
        }
      />

      {showTipoPartDesc ? (
        <TextField
          id="txtTipoPartDesc"
          label="Descrizione"
          size="small"
          fullWidth
          multiline
          rows={2}
          defaultValue={currentAnagraficaFascicolo.tipoPartDesc}
          onChange={onChange}
          inputProps={{ autocomplete: "nope", maxLength: 1024 }}
          readOnly={isCessato || isNotLastVersion}
        />
      ) : null}
    </>
  );
};
